<div class="container" style="align-content: center !important;">
  <p>Your requested has been successfully received .We will contact you soon.</p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Confirm and Continue</button>

</div>
